var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[(_vm.content.surtitle != '')?_c('span',[_vm._v(_vm._s(_vm.content.surtitle))]):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.content.headline))]),(_vm.content.copy != '')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.copy)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f77e3a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/features/Details/index.vue
// module id = lOOt
// module chunks = 1